@import "../../../../styles/variables";
:host {
  display: flex;
  justify-content: right;
  align-items: center;
  height: 46px;
  padding: 0 16px 0 0;
  background-color: $svs-100-background;
}

.filters-reset {
  display: flex;
  justify-content: right;
  align-items: center;
  height: 46px;
  background: none;
  color: #0087cd;

  qds-icon {
    margin-right: 4px;
  }
}
